import { Link } from '@factorialco/deprecated-design-system'
import { BankingValueObjectsOnboardingStatusEnum } from 'generated/resources/graphql'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import BaseNotification from '../Base'

interface Props {
  onboardingStatus: BankingValueObjectsOnboardingStatusEnum
}

const OnboardingNotification = ({ onboardingStatus }: Props) => {
  if (onboardingStatus == 'rejected') return <RejectedAccountNotification />

  return null
}
const RejectedAccountNotification = () => {
  return (
    <BaseNotification
      type="critical"
      compact
      description={i18n.t('expenses_v2.alerts.rejected.description_v2')}
      link={
        <Link.Href href={helpCenterUrl()} target="_blank">
          {i18n.t('expenses_v2.alerts.rejected.contact_support_v2')}
        </Link.Href>
      }
    />
  )
}

export { OnboardingNotification }
